import { useTranslation } from 'react-i18next';
import '@/ui/bootstrapJs';

import { INSTRUCTION_ITEMS, useIncidentRealtime } from '@ngsos/portal-core/chat';
import type { EmergencyInstructionItem } from '@ngsos/portal-core/chat';
import { FaIcon } from '@/ui';

export type EmergencyInstructionsDropdownProps = {
  disabled: boolean;
};

export function EmergencyInstructionsDropdown({ disabled }: EmergencyInstructionsDropdownProps) {
  const { t } = useTranslation();
  const realtime = useIncidentRealtime();

  const sendInstructions = async (item: EmergencyInstructionItem) => {
    await realtime?.sendChatMessage({
      message: t(item.smsTextKey),
      emergencySituationInstructions: item.instructions,
      attachment: null,
    });
  };

  return (
    <div className="dropup">
      <button
        className="btn btn-light btn-sm dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={disabled}
      >
        <FaIcon icon="fal fa-location-crosshairs" />
      </button>
      <ul className="dropdown-menu shadow">
        {INSTRUCTION_ITEMS.map((item) => (
          <li key={item.instructions}>
            <button type="button" className="dropdown-item px-2" onClick={() => void sendInstructions(item)}>
              <FaIcon icon="fal fa-paper-plane-top" />
              <span className="ms-1">{t(item.buttonTextKey)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
